import dayjs from 'dayjs'

import CalendarOutlinedIcon from '@ant-design/icons/CalendarOutlined'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import useDialog from '@shared/hooks/src/useDialog'
import { handleError } from '@shared/utils'

import { PropertyIcon } from '@pages/Dashboard/Provider/components/Property'
import ConfirmationV2 from '@components/Dialog/ConfirmationV2'

import { useTasksFilters } from '../../Tasks.hooks'
import { useMarkCompleted } from './TaskInfo.hooks'
import { isNotDone } from './TaskInfo.utils'

export default function ProviderReminderInfo({ data }) {
  const [, updateFilters] = useTasksFilters()
  const markCompleted = useMarkCompleted(data.id)

  const resolve = useDialog({
    component: ConfirmationV2,
    props: ({ close }) => ({
      title: 'Resolve Reminder Task?',
      description: 'This will mark the reminder task as completed and remove it from your active tasks.',
      variant: 'success',
      rejectLabel: 'Cancel',
      confirmLabel: 'Resolve',
      onReject: () => close(),
      onConfirm: () => {
        return markCompleted
          .mutateAsync()
          .then(() => close())
          .then(() => updateFilters({ task: undefined }))
          .catch(handleError)
      },
    }),
  })

  if (isNotDone(data)) {
    return (
      <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
        <PropertyIcon icon={CalendarOutlinedIcon} label="Due Date" sx={{ minWidth: 150 }}>
          <Typography
            sx={{
              fontVariantNumeric: 'tabular-nums',
              color: dayjs(data.dueDate).isSameOrBefore(dayjs(), 'day') ? 'text.primary' : 'error.main',
            }}
          >
            {dayjs(data.dueDate).format('L')}
          </Typography>
        </PropertyIcon>

        <Button fullWidth variant="contained" onClick={resolve}>
          Resolve
        </Button>
      </Stack>
    )
  }
}
